import React, { useEffect, useState } from 'react'
import {
  Box,
  Flex, Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs, Text
} from "@chakra-ui/react";
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckCloseButton from '../../../global/components/helper-components/components/LaunchdeckCloseButton';
import FormFieldCharactersRemaining from '../../../forms/TextInputField/components/FormFieldCharactersRemaining';



export const DefaultPageSettingsModal = ({
  pageId,
  pageTitle,
  handleClosePageSettingsModal,
  handleEditPageData,
}) => {

  const [displayedPageName, setDisplayedPageName] = useState('');
  const [error, setError] = useState('');

  const nameCharacterLimit = 50;

  useEffect(() => {
    if (pageTitle) {
      setDisplayedPageName(pageTitle)
    }
  }, [pageTitle]);


  const handleClickClosePageSettingsModal = () => {
    setError('')
    setDisplayedPageName("")
    handleClosePageSettingsModal()
  }

  const onChangeHandler = (event) => {
    setError('')

    setDisplayedPageName(event.target.value)
  };

  const handleSavePageSettings = () => {
    if (displayedPageName.length <= 0) {
      setError('pageName')
      return;
    }

    if (!error) {
      let customPageData = {};

      if (displayedPageName !== pageTitle) {
        customPageData.altPageTitle = displayedPageName;
      }

      if (Object.keys(customPageData).length > 0 && pageId) {
        handleEditPageData(customPageData, pageId)
      }

      handleClickClosePageSettingsModal()
    }
  }

  return (
    <Modal isOpen={true} closeOnOverlayClick={false} isCentered={true} preserveScrollBarGap={true} >
      <ModalOverlay />
      <ModalContent display="inline-block" rounded='0.25em' minW={['90%', '500px']} maxW='700px' h='auto'>
        <ModalBody px='0em'>
          <Flex justify='space-between' align='center' w='100%'>
            <Flex px='1.5em' py='0.5em' justify='flex-start' align='center' ml='0.5em'>
              <Box fontSize='1.1em' lineHeight='1.375em' color='brandDark.500'>Page settings</Box>
            </Flex>
            <Box pr='1.5em' display='flex' alignItems='center'>
              <LaunchdeckCloseButton handleCloseModal={handleClickClosePageSettingsModal} />
            </Box>
          </Flex>

          <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
            <Box width='100%'>
              <Tabs width='100%'>
                <TabList padding='0 24px'>
                  <Tab fontSize='0.875em' pr='1em'>Rename page</Tab>
                </TabList>

                <TabPanels padding='24px'>
                  <TabPanel>
                    <Box margin='0 -10px' minHeight='120px'>
                      <Box px='1em'>
                        <Box mb='24px'>
                          <Flex w='100%' justify='space-between' align='center' mb='10px'>
                            <Box fontSize='0.875em'>Page name<Box as='span' color='brandPink.500'>*</Box></Box>
                            <Box>
                              <FormFieldCharactersRemaining
                                currentValue={displayedPageName}
                                characterLimit={nameCharacterLimit}
                              />
                            </Box>
                          </Flex>
                          <Input
                            name='pageName'
                            value={displayedPageName}
                            onChange={onChangeHandler}
                            placeholder="Enter page name"
                            maxLength={nameCharacterLimit}
                            borderColor={error === 'pageName' ? 'brandPink.500' : ""}
                            mb='0.2em'
                            h='1.4em'
                            fontSize='0.875em'
                            fontWeight='400'
                            color='brandDark.500'
                            border='1px solid #A0AEC0'
                            borderRadius='4px'
                            padding='16px'
                          />
                          {error === 'pageName' && <Text color='brandPink.500' fontSize='0.8em'>Give your page a name</Text>}
                        </Box>

                      </Box>
                    </Box>
                    <Flex w='100%'>
                      <Flex align='center' justify='flex-end' w='100%'>
                        <LaunchdeckButton bg='brand.500' color='white' onClick={handleSavePageSettings} px='0.5em' label='OK' />
                      </Flex>
                    </Flex>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
